import { Box } from "@whoosh/design-system/src/components/primitive";

import { TimeListEventsCard } from "../../../../Events/components/TimeListEventsCard/TimeListEventsCard";
import { NoAvailableBookingTimes } from "../components/NoAvailableBookingTimes";
import { RestrictionBlock } from "../components/RestrictionBlock";
import { RestrictionInfoBar } from "../components/RestrictionInfoBar";
import { TimeCard } from "../components/TimeCard";
import { TimeListBlock } from "../components/TimeListBlock";
import { DurationAgendaRowData } from "../types";

interface RenderItemParams {
  item: DurationAgendaRowData;
  index: number;
  agendaId?: string;
}

export const renderTimeListItem = ({
  item,
  index,
  agendaId,
}: RenderItemParams): React.JSX.Element | null => {
  const data = item;

  if (data.type === "Block") {
    return (
      <Box
        px={{ base: 4, agendaSplit: 0 }}
        maxWidth={{ base: "100%", md: 720 }}
        width={"100%"}
        style={{ marginHorizontal: "auto" }}
        key={`block-${data.data.name}-${data.startAt}`}
        testID={`duration-based-agenda-block-${data.data.name}-${data.startAt}`}
      >
        <TimeListBlock {...data.data} />
      </Box>
    );
  }

  if (data.type === "Event") {
    return (
      <Box
        px={{ base: 4, agendaSplit: 0 }}
        maxWidth={{ base: "100%", md: 720 }}
        width={"100%"}
        style={{ marginHorizontal: "auto" }}
        key={`event-${data.key}`}
        marginBottom={4}
        marginTop={2}
        testID={`duration-based-agenda-event-${data.key}`}
      >
        <TimeListEventsCard fragmentRef={data.data} />
      </Box>
    );
  }

  if (data.type === "BlockingRestriction") {
    return (
      <Box
        px={{ base: 4, agendaSplit: 0 }}
        maxWidth={{ base: "100%", md: 720 }}
        width={"100%"}
        style={{ marginHorizontal: "auto" }}
        key={`restriction-${data.data.name}`}
        testID={`duration-based-agenda-restriction-${data.data.name}`}
      >
        <RestrictionBlock {...data.data} />
      </Box>
    );
  }

  if (data.type === "InfoRestriction") {
    return (
      <Box
        px={{ base: 4, agendaSplit: 0 }}
        maxWidth={{ base: "100%", md: 720 }}
        width={"100%"}
        style={{ marginHorizontal: "auto" }}
        key={`restriction-${data.data.name}`}
        testID={`duration-based-agenda-restriction-info-${data.data.name}`}
      >
        <RestrictionInfoBar {...data.data} />
      </Box>
    );
  }

  if (data.type === "AgendaTime") {
    const { key: timeCardKey, ...timeCardProps } = data.data;
    return (
      <Box
        px={{ base: 4, agendaSplit: 0 }}
        maxWidth={{ base: "100%", md: 720 }}
        width={"100%"}
        style={{ marginHorizontal: "auto" }}
        key={`agendatime-${agendaId ?? ""}-${timeCardKey}-${index}`}
        testID={`duration-based-agenda-agendatime-${data.startAt}`}
      >
        <TimeCard
          {...timeCardProps}
          variant={
            timeCardProps.variant as "only" | "first" | "last" | "middle"
          }
        />
      </Box>
    );
  }

  if (data.type === "NoAvailableTimes") {
    return (
      <Box
        px={{ base: 4, agendaSplit: 0 }}
        maxWidth={{ base: "100%", md: 720 }}
        width={"100%"}
        style={{ marginHorizontal: "auto" }}
        key={`no-available-times-${index}`}
        testID={`duration-based-agenda-no-available-times-${index}`}
      >
        <NoAvailableBookingTimes />
      </Box>
    );
  }

  return null;
};
